import { Stack, Typography, Dialog, Button } from '@mui/material'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthToken } from 'hooks/use-auth-token'
import ErrorIcon from '@mui/icons-material/Error'
import { ftueFailStateAtom, FtueFailures } from 'state'
import { useRecoilValue } from 'recoil'
import { useActiveOrganization } from 'hooks/use-organization'
import { COLORS } from 'app-constants'

const Fail = () => {
  const [authToken, setAuthToken] = useAuthToken()
  const failureState = useRecoilValue(ftueFailStateAtom)
  const [, setActiveOrganization] = useActiveOrganization()

  const onFailConfirmed = () => {
    setAuthToken(null)
    setActiveOrganization(null)
  }

  const errorMessage: () => string = () => {
    if (!failureState) {
      return 'Sorry, an error has occurred'
    }

    switch (failureState) {
      case FtueFailures.AccountCreationFailure:
        return 'Sorry, account creation failed'
      case FtueFailures.TrendUpdateFailure:
        return 'Sorry, trend update failed'
      case FtueFailures.OrganizationCreationFailure:
        return 'Sorry, company profile creation failed'
    }
  }

  let navigate = useNavigate()

  useEffect(() => {
    if (authToken == null) {
      navigate('/', { replace: true })
    }
  }, [authToken, navigate])

  return (
    <Dialog open={true}>
      <Stack justifyContent="flex-end" alignItems="center" spacing={4} m={4}>
        <ErrorIcon color="error" style={{ fontSize: 96 }} />
        <Stack justifyContent="flex-end" alignItems="center" spacing={0}>
          <Typography variant="h6" color="#222222">
            {errorMessage()}
            {'. '}Please reach out to{' '}
          </Typography>
          <Typography variant="h6" color="#222222">
            <a
              href="mailto:support@jelled.ai"
              style={{ color: COLORS.JELLED_PRIMARY_BLUE, textDecoration: 'none' }}
              target="_blank"
              rel="noreferrer">
              support@jelled.ai
            </a>{' '}
            for further assistance.
          </Typography>
        </Stack>
        <Button variant="contained" size="large" color="secondary" onClick={onFailConfirmed}>
          Got it
        </Button>
      </Stack>
    </Dialog>
  )
}

export default Fail
